<script>
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'SourceFilter',

  extends: BaseSelectFilter,

  methods: {
    ...mapCacheActions('inhabitant_changes', ['getSources']),

    getData() {
      return this.getSources().then(({ data }) => {
        return data;
      });
    }
  }
};
</script>
